export default {
  props: {
    title: ''
  },
  data: function data() {
    return {};
  }
};